import ProvianteResponse from 'api/proviante/response'
import axios from 'axios'
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'core/constants'
import AuthResponse from 'modules/auth/types/response/auth'
import env from 'core/env'

type TokenRefreshListener = () => void

class TokenRefreshManager {
  private static instance: TokenRefreshManager
  private refreshPromise: Promise<void> | null = null
  private listeners = new Set<TokenRefreshListener>()

  public refresh(): Promise<void> {
    if (this.refreshPromise) {
      return this.refreshPromise
    }
    this.refreshPromise = this.doRefresh().finally(() => {
      this.refreshPromise = null
    })
    return this.refreshPromise
  }

  public onTokenRefreshed(listener: TokenRefreshListener): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  private async doRefresh(): Promise<void> {
    try {
      const refreshToken = localStorage.getItem(REFRESH_TOKEN)
      if (!refreshToken) {
        throw new Error('Нет доступного refresh токена')
      }
      const response = await axios.post<ProvianteResponse<AuthResponse>>(
        `${env.string('VITE_AUTH_BASE_URL', '') ?? ''}/api/v1/external/refresh-token`,
        {
          refreshToken,
          clientId: env.string('VITE_AUTH_CLIENT_ID', ''),
          clientSecret: env.string('VITE_AUTH_CLIENT_SECRET', ''),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      localStorage.setItem(ACCESS_TOKEN, response.data.data.token.accessToken)
      localStorage.setItem(REFRESH_TOKEN, response.data.data.token.refreshToken)
      this.listeners.forEach((listener) => {
        try {
          listener()
        } catch (e) {
          console.error('TokenRefreshManager listener failed:', e)
        }
      })
    } catch (error) {
      localStorage.removeItem(ACCESS_TOKEN)
      localStorage.removeItem(REFRESH_TOKEN)
      window.location.href = '/login'
      throw error
    }
  }

  public static getInstance(): TokenRefreshManager {
    if (!this.instance) {
      this.instance = new TokenRefreshManager()
    }
    return this.instance
  }
}

export default TokenRefreshManager
